import { useEffect, useState } from 'react';
import Constants from 'expo-constants';

const useLiveService = () => {
    const [liveService, setLiveService] = useState();
    const uri = Constants.expoConfig.extra?.apiUrl + '/GetNextStreamingEvent';

    useEffect(() => {
        async function getNextLiveService() {
            const response = await window.fetch(uri, { method: 'POST' });
            const nextLiveService = await response.json();

            if (nextLiveService) {
                setLiveService(nextLiveService);
            }
        }

        if (!liveService) {
            getNextLiveService();
        }
    });

    return liveService;
};

export default useLiveService;
